import { render, staticRenderFns } from "./DispensationTask.vue?vue&type=template&id=7aef5e83&scoped=true&"
import script from "./DispensationTask.vue?vue&type=script&lang=js&"
export * from "./DispensationTask.vue?vue&type=script&lang=js&"
import style0 from "./DispensationTask.vue?vue&type=style&index=0&id=7aef5e83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef5e83",
  null
  
)

export default component.exports